import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthorizationService } from '../services/authorization.service';
import { Observable, forkJoin, map, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  constructor(private authorizationService: AuthorizationService, private router: Router) {}
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const requiredPermission = next.data['requiredPermission'];  
    const permissionsArray = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
  
    if (this.authorizationService.userPermissions$.getValue() === null || this.authorizationService.userPermissions$.getValue().length === 0) {
      
      return this.authorizationService.fetchPermissionsFromServer().pipe(
        switchMap((permissionsFromServer: string[]) => {
          const permissionObservables = permissionsArray.map(permission => {
            return this.authorizationService.hasPermissions(permission, permissionsFromServer);
          });

          return forkJoin(permissionObservables).pipe(
            map(permissions => {
              const hasAllPermissions = permissionsArray.includes('||')
                ? permissions.some(permission => !!permission)
                : permissions.every(permission => !!permission);

              if (hasAllPermissions) {
                return true;
              } else {
                this.router.navigate(['/error/401']);
                return false;
              }
            })
          );
        })
      );
    } else {
      return this.authorizationService.userPermissions$.pipe(
        switchMap((permissionsFromUser: string[]) => {
          const permissionObservables = permissionsArray.map(permission => {
            return this.authorizationService.hasPermissions(permission, permissionsFromUser);
          });

          return forkJoin(permissionObservables).pipe(
            map(permissions => {
              const hasAllPermissions = permissionsArray.includes('||')
                ? permissions.some(permission => !!permission)
                : permissions.every(permission => !!permission);

              if (hasAllPermissions) {
                return true;
              } else {
                this.router.navigate(['/error/401']);
                return false;
              }
            })
          );
        })
      );
    }
  }
  
  
  
  // canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      
  //     const requiredPermission = next.data['requiredPermission'];
  //     console.log('AuthorizationGuard....',requiredPermission);

  //     const permissionsArray = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];

  //     console.log('AuthorizationGuard2....',permissionsArray,this.checkPermissions(permissionsArray));
      
  //   if (this.checkPermissions(permissionsArray)) {
  //     return true;
  //   } else {
  //     this.router.navigate(['/error/401']);
  //     return false;
  //   }
  // }


  checkPermissions(permissions: any): boolean {

    if (permissions.includes('||')) {
      const validPermissions = permissions.filter(
        (permission: any) => permission !== '||'
      );


      return validPermissions.some((permission: any) =>
        this.authorizationService.hasPermission(permission)
      );
    } else if (permissions.includes('&&')) {
      const validPermissions = permissions.filter(
        (permission: any) => permission !== '&&'
      );
     
      return validPermissions.every((permission: any) =>
        this.authorizationService.hasPermission(permission)
      );
    } else {
      return this.authorizationService.hasPermission(permissions[0]);
    }
  }
}
